exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Avatar-imgBackground-3Fu2o {\n\tbackground-color: #bbb;\n}", "", {"version":3,"sources":["/root/bettertrip-web-app/src/components/Avatar/Avatar.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB","file":"Avatar.css","sourcesContent":[".imgBackground {\n\tbackground-color: #bbb;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"imgBackground": "Avatar-imgBackground-3Fu2o"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Avatar/Avatar.css
// module id = 2577
// module chunks = 8